export const SET_HEADER_DATA = "SET_HEADER_DATA";

export const setHeaderData = (data) => ({
  type: SET_HEADER_DATA,
  payload: data,
});

